import { useEffect, useState } from "react";
import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "quilljs-markdown/dist/quilljs-markdown-common-style.css";
import QuillMarkdown from "quilljs-markdown";
import { formats } from "./EditorToolbar.js";
import { remark } from "remark";
import remarkHtml from "remark-html";
import rehypeParse from "rehype-parse";
import rehypeRemark from "rehype-remark";
import remarkStringify from "remark-stringify";

function markdownToHtml(markdownText) {
  const file = remark().use(remarkHtml).processSync(markdownText);
  return String(file);
}

function htmlToMarkdown(htmlText) {
  const file = remark()
    .use(rehypeParse, { emitParseErrors: true, duplicateAttribute: false })
    .use(rehypeRemark)
    .use(remarkStringify)
    .processSync(htmlText);

  return String(file);
}

const QuillToolbar = ({ id, show }) => {
  return (
    <div className={`myToolbar ${show ? "" : "hide"}`}>
      <div id={id}>
        <span className="ql-formats">
          <select className="ql-font" defaultValue="arial">
            <option value="arial">Arial</option>
            <option value="comic-sans">Comic Sans</option>
            <option value="courier-new">Courier New</option>
            <option value="georgia">Georgia</option>
            <option value="helvetica">Helvetica</option>
            <option value="lucida">Lucida</option>
          </select>
          <select className="ql-size" defaultValue="medium">
            <option value="extra-small">Size 1</option>
            <option value="small">Size 2</option>
            <option value="medium">Size 3</option>
            <option value="large">Size 4</option>
          </select>
          <select className="ql-header" defaultValue="3">
            <option value="1">Heading</option>
            <option value="2">Subheading</option>
            <option value="3">Normal</option>
          </select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold" />
          <button className="ql-italic" />
          <button className="ql-underline" />
          <button className="ql-strike" />
        </span>
        <span className="ql-formats">
          <button className="ql-list" value="ordered" />
          <button className="ql-list" value="bullet" />
          <button className="ql-indent" value="-1" />
          <button className="ql-indent" value="+1" />
        </span>
        <span className="ql-formats">
          <button className="ql-script" value="super" />
          <button className="ql-script" value="sub" />
          <button className="ql-blockquote" />
          <button className="ql-direction" />
        </span>
        <span className="ql-formats">
          <select className="ql-align" />
          <select className="ql-color" />
          <select className="ql-background" />
        </span>
        <span className="ql-formats">
          <button className="ql-link" />
          <button className="ql-image" />
          <button className="ql-video" />
        </span>
        <span className="ql-formats">
          <button className="ql-formula" />
          <button className="ql-code-block" />
          <button className="ql-clean" />
        </span>
      </div>
    </div>
  );
};

const QuillEditor = ({ id, setValue, value, onFocus, currentToolbar }) => {
  const modules = {
    toolbar: {
      container: `#${id}`,
    },
    markdownOptions: {
      markdown: QuillMarkdown,
    },
  };

  return (
    <ReactQuill
      onFocus={() => (currentToolbar !== id ? onFocus(id) : null)}
      value={value}
      onChange={setValue}
      placeholder={"Flow guide XR..."}
      modules={modules}
      formats={formats}
    />
  );
};

export const Editor = ({ optionList, steoptionsList, setMarkdownList }) => {
  const [toolbar, setToolbar] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (optionList?.length) {
      const options = optionList.map((e) => {
        e.id = e.id;
        e.value = markdownToHtml(e.value);
        return e;
      });
      setOptions(() => options);
      steoptionsList(() => options);
      setToolbar(() => optionList[0]?.id);
    }
  }, []);

  const handleValueChange = (id, ele) => {
    const newOptions = options.map((e, index) => {
      if (e.id === id) {
        e.value = ele;
      }
      return e;
    });
    setOptions(() => newOptions);
    steoptionsList(() => newOptions);
    const markDownList = newOptions.map((e) => htmlToMarkdown(e.value));
    setMarkdownList(() => markDownList);
  };

  return (
    <>
      {optionList?.map((e) => {
        return <QuillToolbar id={`${e.id}`} show={toolbar == `${e.id}`} />;
      })}
      <div className="custom-editors">
        <div className="editorarea">
          {optionList?.map((e) => {
            return (
              <QuillEditor
                id={`${e.id}`}
                value={e.value}
                setValue={(ele) => handleValueChange(e.id, ele)}
                onFocus={setToolbar}
                currentToolbar={toolbar}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default { Editor };
